module.exports = __webpack_public_path__ + "static/media/useravatar.c51b1c22.svg";